import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { getTranslations } from "../../Shared/translations";
import { outputOptions } from "../../Shared/sharedInterfaces";

interface MyProps {
  visible: boolean;
  onDmxClose: (tdmxVisible: boolean, id: number) => any;
  onDmxSelect: (t: any) => any;
}

const DmxOptions: React.FC<MyProps> = ({ visible, onDmxClose, onDmxSelect }) => {
  const [dmxChoice, setDmxChoice] = useState<number>(0);
  const t = getTranslations();
  const handleClose = () => {
    onDmxClose(false, dmxChoice);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value, 10);
    setDmxChoice(value);
    // Optional: notify parent on change
    // onDmxSelect(value);
  };

  return (
    <Modal show={visible}>
      <Modal.Header>
        <Modal.Title>
          <h1>DMX</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormControl className="projectsFrom">
          <FormLabel id="dmx-radio-group-label"></FormLabel>
          <RadioGroup
            aria-labelledby="dmx-radio-group-label"
            name="controlled-radio-buttons-group"
            className="customCardName"
            onChange={handleChange}
          >
            <FormControlLabel
              key={"dmx1"}
              value={1}
              control={<Radio />}
              label={t.dmx1}
            />
            <FormControlLabel
              key={"dmx2"}
              value={6}
              control={<Radio />}
              label={t.dmx6}
            />
            <FormControlLabel
              key={"dmx3"}
              value={8}
              control={<Radio />}
              label={t.dmx8}
            />
            <FormControlLabel
              key={"dmx4"}
              value={4}
              control={<Radio />}
              label={t.dmx4}
            />
          </RadioGroup>
        </FormControl>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DmxOptions;
